import { TranslationKeys } from '~frontend-common/i18n/english/base-segment.i18n';

const keys: TranslationKeys = {
  baseSegment: {
    placeholders: {
      address: '500 Avenue des Pins, Montréal',
      addressCity: 'Ville',
      addressStreetName: 'Rue',
      addressStreetNumber: 'Numéro',
      addressUnit: '# Suite',
      areaNotAvailable: {
        email: 'Courriel',
      },
      constructionYear: 'ex. 2016',
      currentInsurer: 'Ex. Intact',
      email: 'Courriel',
      firstName: 'Prénom',
      genericDate: 'jj/mm/aaaa',
      homeReconstructionCost: 'ex. 250 000',
      lastName: 'Nom de famille',
      monthDate: '',
      numberOfUnits: '75',
      occupation: 'Ex. Santé',
      phoneNumber: 'ex. (514) 555-5555',
      postalCode: 'Code postal',
      productNotAvailable: {
        email: 'Courriel',
        renewalMonth: 'Mois du renouvellement',
      },
      dogBreed: 'ex. Golden retriever, caniche',
      province: 'Province',
      waterTankYear: 'ex. 2015',
      electricalSystemReplacementYear: 'ex. 2015',
      plumbingReplacementYear: 'ex. 2015',
      windowsAndDoorsReplacementYear: 'ex. 2015',
    },
    titles: {
      additionalDrivers: 'Ajoutez tous les conducteurs additionnels',
      additionalHeating: 'Avez-vous des systèmes de chauffage supplémentaires?',
      additionalOilTankLocation: "Où se situe le réservoir à l'huile du système de chauffage additionnel?",
      address: 'Quelle est votre adresse?',
      addressNotCompleted: "Pouvez-vous s'il vous plaît compléter les informations manquantes?",
      addressNotFound: 'Ça arrive. Essayons de nouveau.',
      electricalDetails: "Quel est l'ampérage de votre maison?",
      electricalWiringType: 'Quel type de câblage électrique avez-vous dans tout le bâtiment?',
      electricalSystemReplacementYear:
        'Quand avez-vous complètement remplacé le panneau électrique et le câblage pour la dernière fois à 100%?',
      plumbingReplacementYear: 'Quand avez-vous complètement remplacé la plomberie pour la dernière fois à 100%?',
      windowsAndDoorsReplacementYear:
        'Quand avez-vous complètement remplacé les fenêtres et les portes pour la dernière fois à 100%?',
      hasBackwaterValve: 'Avez-vous un clapet anti-retour?',
      hasFrenchDrain: 'Avez-vous un drain français?',
      basementCondition: 'Y a-t-il un sous-sol?',
      birthday: 'Quelle est votre date de naissance?',
      businessOccupancy: 'Habitez-vous dans un immeuble où des entreprises opèrent?',
      carClaims: 'Ajoutez tous vos accidents ou sinistres automobiles dans les 6 dernières années',
      carCreditors: 'Qui a financé votre véhicule et quelle est l’adresse du prêteur?',
      carLegalConsent: {
        quebec:
          'Afin de vous aider à économiser jusqu’à 25% de plus, nous devons vérifier votre dossier de crédit et votre dossier de sinistres au Fichier Central des Sinistres Automobiles (FCSA)',
        ontario:
          'Afin de vous aider à économiser jusqu’à 25% de plus, nous devons vérifier le Motor Vehicle Records (MVR) et DASH.',
      },
      carContinuouslyCoverage:
        'Avez-vous actuellement une assurance automobile? Si oui, depuis combien d’années êtes-vous assuré sans interruption?',
      cars: 'On commence, parlez-nous de vos voitures.',
      carsDriverAssignments: 'Assignez le conducteur principal et occasionnel de chaque voiture.',
      dogBreed: 'Quelle est la race de votre chien?',
      disclaimer: "Dernière étape avant d'obtenir votre soumission! Sélectionnez tous les éléments qui s'appliquent.",
      discounts:
        'Il est maintenant temps de savoir si vous êtes éligible à des rabais. Sélectionnez tout ce qui vous décrit ci-dessous.',
      driverLicenceDetails: {
        quebec: 'À quel âge avez-vous obtenu votre permis de conduire au Québec?',
        ontario: 'À quel âge avez-vous obtenu votre permis de conduire en Ontario?',
      },
      drivingConvictions: 'Ajoutez toutes les contraventions routières reçues dans les 5 dernières années',
      email: 'Quelle est votre adresse courriel?',
      floorNumber: 'À quel étage habitez-vous?',
      garages: "Votre maison dispose-t-elle d'un garage?",
      gender: 'Qu’est-ce qui vous décrit le mieux?',
      homeAmenities: 'Nous avons besoin de quelques détails additionnels',
      homeClaims: 'Dans les 8 dernières années, avez-vous fait des réclamations en assurance habitation?',
      homeContinuouslyCoverage:
        'Avez-vous une assurance habitation actuellement? Si oui, depuis combien d’années êtes-vous assuré sans interruption?',
      homeLegalConsent:
        'Afin de vous aider à économiser jusqu’à 25% de plus, nous devons vérifier votre dossier de crédit.',
      homeExteriorMaterial: 'Quel est le type de revêtement extérieur?',
      homeReconstructionCost: 'Confirmez le coût de reconstruction de votre résidence avec des matériaux équivalents.',
      homeSecurity: 'Sélectionnez ci-dessous tout ce qui décrit la sécurité de votre domicile:',
      homeStructureCondition: 'Décrivez-nous la structure de votre maison',
      homeStructureType: "Comment décririez-vous le type d'habitation?",
      isOwner: 'Êtes-vous locataire ou propriétaire?',
      insulationType: "Quel type d'isolation est utilisé dans tout le bâtiment?",
      moveInDetails: {
        car: 'Quand avez-vous déménagé à cette adresse?',
        home: {
          condo: 'Quand avez-vous ou allez-vous déménager dans ce condo?',
          homeowner: 'Quand avez-vous ou allez-vous déménager dans cette maison?',
          tenant: 'Quand avez-vous ou allez-vous déménager dans cet appartement?',
        },
      },
      numberOfMortgages: {
        home: {
          condo: 'Avez-vous une hypothèque sur votre condo?',
          homeowner: 'Avez-vous une hypothèque sur votre maison?',
        },
      },
      occupation: 'Dans quel domaine travaillez-vous?',
      oilTankLocation: "Où se situe le réservoir à l'huile?",
      ownershipType: 'Quel type de propriété possédez-vous?',
      pets: 'Avez-vous des animaux domestiques?',
      phoneNumber: 'Quel est votre numéro de téléphone?',
      pool: 'Avez-vous une piscine?',
      spa: 'Avez-vous un spa?',
      primaryHeating: 'Quel est votre système de chauffage principal?',
      propertyCharacteristics: 'Confirmez les informations suivantes concernant votre adresse.',
      registeredCarOwners:
        "À part vous, y a-t-il d'autres propriétaires immatriculés sur le certificat d'immatriculation des voitures?",
      unemployed: 'Pouvez-vous confirmer votre occupation?',
      userName: 'Quel est votre nom?',
      waterHeatingType: 'Quel est le type de votre système de chauffage à eau chaude?',
      waterTankYear: 'Quelle est l’année de votre réservoir à eau chaude?',
    },
    subtitles: {
      additionalHeating: 'Les systèmes de chauffage doivent être certifiés et installés par un professionel.',
      businessOccupancy: 'Toute entreprise comme un restaurant, un magasin, une clinique dentaire, etc.',
      carClaims:
        "L'omission d'informations affectera l'exactitude de votre prime et les compagnies d'assurance auront accès à ces informations avant de vous vendre une police.",
      carLegalConsent: {
        quebec: 'Ces vérifications n’affectent pas votre cote de crédit ni votre dossier de sinistres.',
        ontario: 'Ces vérifications n’affectent pas votre dossier de conduite ou de sinistres.',
      },
      carCreditors: 'Notez que des réponses incorrectes peuvent invalider la soumission.',
      dogBreed: 'Listez toutes les races si vous avez plusieurs chiens.',
      discounts: 'Si vous êtes entrepreneur ou pigiste, sélectionnez travail à temps plein.',
      email: "C'est à ce courriel que nous vous enverrons une copie de votre soumission.",
      homeLegalConsent: 'Cette vérification n’affecte pas votre cote de crédit.',
      homeReconstructionCost:
        "Le coût de reconstruction n'est pas le même que la valeur marchande ou la valeur foncière municipale. Il exclut la valeur du terrain.",
      homeSecurity:
        "Une alarme centrale est reliée à une centrale de surveillance et avertit des professionnels en cas d'activation.",
      numberOfClaims: 'Nous ne jugeons pas. Ces informations nous aideront à vous présenter une soumission exacte.',
      phoneNumber: 'Nous vous appellerons uniquement si nous ne pouvons pas communiquer les informations par SMS.',
      primaryHeating: 'Le système de chauffage doit être certifié et installé par un professionel.',
      userName: {
        car: 'Afin d’obtenir les meilleurs prix, écrivez votre nom tel qu’il est inscrit sur votre permis de conduire.',
        home: 'Vous pourrez ajouter une autre personne à votre contrat plus tard.',
      },
      waterTankYear: "Si vous n’avez pas de réservoir dans votre unité, demandez à votre gestionnaire d'immeuble.",
      yearsContinuouslyInsured: 'Sélectionnez «Je ne suis pas assuré» si votre nom n’est pas inscrit sur la police.',
    },
    helpers: {
      // Car
      carContinuouslyCoverage: {
        description:
          'Calculez depuis combien d’années vous détenez une assurance automobile sans interruption. Par exemple, si vous avez été assuré chez Assureur A pour 2 ans et que vous avez changé pour Assureur B (sans aucun délai où vous n’étiez plus assuré) pour les 3 dernières années, sélectionnez 5 ans.',
      },
      registeredCarOwners: {
        description:
          'Une personne est le propriétaire immatriculé si son nom est sur le certificat d’immatriculation du véhicule. Cette personne, considérée comme co-assurée, peut agir en votre nom pour modifier ou résilier la police d’assurance.',
      },
      carLegalConsent: {
        ontario: {
          description:
            'Historique des pilotes et de la recherche automatique (DASH) est un système d’information sur les polices et les réclamations conçu pour récupérer les données des conducteurs et des automobiles pour l’industrie canadienne de l’assurance.',
        },
      },

      // Home
      primaryHeating: {
        cells: {
          primaryHeating: {
            description:
              'Le système de chauffage doit être certifié et installé par un professionnel.<0></0><1></1> Un système de chauffage est certifié s’l a été approuvé par l’Association canadienne de Normalisation (CSA), l’Association canadienne de gaz (CGA) et homologué par les Laboratoires des assureurs du Canada (ULC), Warnock Hersey (W-H), Omni Test Laboratories (OTL) ou Electrical Testing Laboratories (ETL).',
          },
        },
      },
      additionalHeating: {
        cells: {
          additionalHeating: {
            description:
              "Tous les systèmes de chauffage doivent être certifiés et installés par un professionel.<0></0><1></1> Un système de chauffage est certifié s'il a été approuvé par l'Association canadienne de Normalisation (CSA), l'Association canadienne de gaz (CGA) et homologué par les Laboratoires des assureurs du Canada (ULC), Warnock Hersey (W-H), Omni Test Laboratories (OTL) ou Electrical Testing Laboratories (ETL).",
          },
        },
      },
      homeStructureType: {
        cells: {
          detached: {
            title: 'Détaché',
            description: 'Le bâtiment n’est pas attaché à d’autres bâtiments (sauf à son propre garage ou hangar).',
          },
          endRowBuilding: {
            title: "Bâtiment à l'extrémité",
            description:
              "Le bâtiment est situé à l’extrémité d’une rangée d'au moins trois logements réunis côte à côte.",
          },
          inRowBuilding: {
            title: 'Bâtiment au milieu',
            description: "Le bâtiment est situé au milieu d’une rangée d'au moins trois logements réunis côte à côte.",
          },
          semiDetached: {
            title: 'Semi Détaché',
            description:
              "Le bâtiment partage un mur avec une autre maison ou bâtiment (sauf à son propre garage ou hangar), mais seulement d'un côté, et les autres côtés du logement sont ouverts.",
          },
        },
      },
      electricalDetails: {
        description:
          "L’ampérage désigne l’intensité du courant en ampère (AMP) du bâtiment. Cherchez l'étiquette de spécifications sur la boîte électrique de votre maison ou demandez l'aide d'un électricien.",
      },
      homeExteriorMaterial: {
        cells: {
          aluminium: {
            title: 'Aluminium',
            description: 'Le revêtement extérieur du bâtiment est principalement composé d’aluminium.',
          },
          masonry: {
            title: 'Maçonnerie',
            description: 'Le revêtement extérieur du bâtiment est principalement composé de briques.',
          },
          stone: {
            title: 'Pierre',
            description: 'Le revêtement extérieur du bâtiment est principalement composé de pierre.',
          },
          stuco: {
            title: 'Stuc / Aggrégat',
            description:
              "Le revêtement extérieur du bâtiment est principalement composé de stuc (stucco) ou d'agrégat. Ces matériaux sont des enduits semblables à du plâtre formé d’un mélange de ciment, de sable et d’eau.",
          },
          vinyl: {
            title: 'Vinyle',
            description: 'Le revêtement extérieur du bâtiment est principalement composé de vinyle.',
          },
          wood: {
            title: 'Bois',
            description:
              "Le revêtement extérieur du bâtiment est principalement composé de bois, de bois d'ingénierie ou de fibre de bois.",
          },
        },
      },
      homeReconstructionCost: {
        cells: {
          homeReconstructionCost: {
            description:
              "Le coût de reconstruction est le montant nécessaire pour reconstruire votre résidence après une perte totale (le coût pour démolir et reconstruire), incluant la main d'œuvre et les matériaux neufs. Vous pouvez vous référer au coût de reconstruction inscrit à votre police d'assurance habitation actuelle.<0></0><1></1>Ne pas confondre le coût de reconstruction avec la valeur marchande, ni la valeur sur l’évaluation municipale.<2></2><3></3>À noter qu'il est possible que le coût de reconstruction soit ajusté, lorsqu'un de nos courtiers en assurance de dommages révisera votre dossier, afin de mieux répondre à vos besoins. Cet ajustement pourrait avoir une incidence sur la prime.",
          },
        },
      },
      homeContinuouslyCoverage: {
        cells: {
          homeContinuouslyCoverage: {
            description:
              "<0>Que veut dire assurance habitation?</0><1></1> <2>Une assurance habitation inclut les assurances locataire, condo et maison.</2> <3></3><4></4> <5>Comment dois-je calculer le nombre d'années?</5> <6></6> <7>Calculez depuis combien d’années vous détenez une assurance habitation sans interruption. Par exemple, si vous avez été assuré chez Assureur A pour 2 ans et que vous avez changé pour Assureur B (sans aucun délai où vous n’étiez plus assuré) pour les 3 dernières années, sélectionnez 5 ans.</7>",
          },
        },
      },
    },
    multiProductDiscount: 'Rabais multi-produit débloqué',
    emailValidationWarning: 'Votre adresse courriel semble inhabituelle. Vouliez-vous dire <0>{{0}}</0>?',
  },
};

export default keys;
